//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
let d=[[[0,"ContainmentType",1,0],[0,"PointType",1,0]],[[["count","startPoint"],"GetStartPoints",{},0,0],[["startPoint"],"SetStartPoints",{},1,0]],[]];
SPLM.CAM.EditSubopCommand = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.EditSubopCommand";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.EditSubopCommand.PointTypes = Object.freeze({
    "Specify" : "Specify", "Automatic" : "Automatic"});

SPLM.CAM.EditSubopCommand.ContainmentTypes = Object.freeze({
    "Steep" : "Steep", "NonSteep" : "NonSteep", "Flat" : "Flat"});

export default SPLM;